export default __webpack_public_path__ + "static/media/close.d5f87549.svg";